import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-full-data-iban-table',
    templateUrl: './full-data-iban-table.component.html',
    styleUrls: ['./full-data-iban-table.component.scss'],
})
export class FullDataIbanTableComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    iban: string;

    @Input()
    isAdmin = false;

    @Input()
    isComplete = false;

    @Input()
    isValidated = false;

    @Output()
    edit: EventEmitter<void> = new EventEmitter();

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    get maskIban(): string {
        let i = 0;
        return '#### #### #### ## ##########'.replace(/#/g, (_) => this.iban[i++] || '');
    }

    onEdit() {
        this.edit.next();
    }
}
